import styled from 'styled-components'
import theme from '@/styles/theme'

import DoubleHeroImgURL from '@/images/img-women.jpg'

const Container = styled.section`
  position: relative;
  /* margin-top: 10vh; */
  overflow: hidden;
  max-width: ${theme.overWidth};
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  & :before {
    @media (max-width: 1000px) {
      position: absolute;
      content: '';
      left: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 80%
      );
    }

    @media (max-width: 500px) {
      position: absolute;
      content: '';
      left: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 70%;
  @media (min-width: 500px) {
    background-size: 90%;
    /* background-size: cover; */
    background-position: bottom right;
  }
  @media (min-width: 1000px) {
    background-size: 70%;
    background-position: bottom right;
  }

  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;

  width: 100%;
  padding: 10vh;
  justify-content: space-between;
  flex-direction: row;
  background-image: ${'url(' + DoubleHeroImgURL + ')'};
  @media (orientation: portrait) {
    padding: 6vh 2vh;
  }
`
const TextHolder = styled.div`
  color: ${theme.black};
  height: 80vh;
  justify-content: center;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  align-self: center right;

  @media (min-width: 500px) {
    min-width: 100%;
  }
  @media (min-width: 1000px) {
    min-width: 75%;
  }

  p {
    max-width: 20rem;
    line-height: 1.4rem;
    z-index: 3;
    font-size: 1.2rem;
  }

  h2 {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${theme.fonttitle4};
    /* font-style: italic; */
    z-index: 3;
    font-size: 2.6rem;
    margin-bottom: 0.1rem;

    /* @media (max-width: 600px) {
			margin-top: -25vh;
			  text-rendering: optimizeLegibility;
		} */
  }
`
const Button = styled.a`
  cursor: pointer;
  transition: all 300ms ease-out;
  font-size: 1.2rem;
  letter-spacing: 0.04rem;
  font-family: ${theme.fonttitle4};
  font-weight: 900;
  width: auto;
  display: block;
  max-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${theme.red};
  margin-left: 0;
  margin-right: auto;
  border-radius: 2rem;
  padding: 1rem 4rem;
  margin-block-start: 1rem;
  margin-block-end: 1rem;
  z-index: 3;
  text-decoration: none;
  user-select: none;

  &:hover,
  &:active {
    color: black;
    background-color: ${theme.darkGray};
  }
`
const Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 20%;
    background: linear-gradient(transparent, ${theme.background});
  }
`

export { Container, Content, Bg, TextHolder, Button }
